export default {
	brands: "Marcas",
	mystery_shopper: "Cliente Misterioso",
	of_the_points: "dos pontos",
	photos: "Fotos",
	practice_display_and_recommend_products_with_intel_tecnology_and_you_can_redeem_the_best_prizes: "No programa Intel Te Premia, você pode acumular pontos e trocá-los por prêmios e benefícios incríveis! Vamos lá!",
	processors: "Processadores",
	product_types: "Tipos de Produto",
	pts: "pts.",
	score: "Pontos",
	training_kpi_points: "Treinamento",
	trainings_kpi: "Treinamento KPI",
	trainings_non_kpi: "Treinamento não KPI"
}